import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/browser';

import './index.css';
import App from './App';


if ((window as any).sentryDSN) {
  Sentry.init({
    dsn: (window as any).sentryDSN
  });
}


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('gatorstep_client_renderer')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
